export default "__VITE_ASSET__Cuw_rTNF__"